<template>
  <!-- ============================ -->
  <!-- TAB 4: CONTAINER e.g. box    -->
  <!-- ============================ -->
  <div>
    <!-- -------------- -->
    <!--  container size -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Container Details</p>
    <!-- -------------- -->
    <!--     ROW 1      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- ---------------------------- -->
      <!--   container size long (r/o)  -->
      <!-- ---------------------------- -->
      <div class="col-4 form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="activeItem.container_size_long"
            id="container_size_long"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="container_size_long"
            >Container Size</label
          >
        </div>
      </div>
      <!-- ------------------------------- -->
      <!--   container size short (r/o)    -->
      <!-- ------------------------------- -->
      <div class="col-2 form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="activeItem.container_size_short"
            id="container_size_short"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="container_size_short"
            >Short</label
          >
        </div>
      </div>
      <!-- ------------------------------ -->
      <!--  direct contents count (r/o)   -->
      <!-- ------------------------------ -->
      <div class="col form-group">
        <ToolTip
          :text="displayDirectCnt"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="activeItem.contents_count_direct"
              id="contents_count_direct"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="contents_count_direct"
              >Direct Items
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
      <!-- ---------------------------------------- -->
      <!--  total contents count (r/o)              -->
      <!--  (direct contents + nested child items)  -->
      <!-- ---------------------------------------- -->
      <div class="col form-group">
        <ToolTip
          :text="displayTotalCnt"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="activeItem.contents_count_total ?? 0"
              id="contents_count_total"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="contents_count_total"
              >Total Items
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
    </div>
    <!-- -------------- -->
    <!--     ROW 2      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- ------------------------ -->
      <!--   container enc (r/o)    -->
      <!-- ------------------------ -->
      <div class="col-4 form-group">
        <ToolTip
          :text="displayContainerEnc"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="formatEnc(activeItem.enc)"
              id="container_enc"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="container_enc"
              >Container Enc
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
      <!-- --------------------- -->
      <!--   capacity enc (r/o)  -->
      <!-- --------------------- -->
      <div class="col-4 form-group">
        <ToolTip
          :text="displayCapacityEnc"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="formatEnc(activeItem.container_capacity)"
              id="capacity"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="capacity"
              >Capacity Enc
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
      <!-- --------------------- -->
      <!--   contents enc (r/o)   -->
      <!-- ---------------------- -->
      <div class="col form-group">
        <ToolTip
          :text="displayContentsEnc"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="formatEnc(activeItem.contents_enc)"
              id="contents_enc"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="contents_enc"
              >Contents Enc
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
    </div>
    <!-- -------------- -->
    <!--     ROW 3      -->
    <!-- -------------- -->
    <div class="row mt-2 mb-2">
      <!-- ------------------- -->
      <!--   total enc (r/o)   -->
      <!-- ------------------- -->
      <div class="col-4 form-group">
        <ToolTip
          :text="displayTotEnc"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="formatEnc(activeItem.tot_enc)"
              id="tot_enc"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="tot_enc"
              >Total Enc
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
      <!-- ---------------------- -->
      <!--   available enc (r/o)  -->
      <!-- ---------------------- -->
      <div class="col-4 form-group bb-tooltip-wrapper">
        <ToolTip
          :text="displayAvailableEnc"
          position="bottom"
        >
          <div class="form-floating">
            <input
              readonly
              class="form-control text-center"
              :value="
                formatEnc(
                  activeItem.container_capacity - activeItem.contents_enc,
                )
              "
              id="avail_enc"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="avail_enc"
              >Avail Enc
              <span class="bb-orange-circle"></span>
            </label>
          </div>
        </ToolTip>
      </div>
    </div>
    <!-- -------------- -->
    <!--     ROW 4      -->
    <!-- -------------- -->
    <div
      v-if="activeItem.contents_count_direct > 0"
      class="row mt-3 mb-2"
    >
      <p class="bb-sub-hdg mb-3 mt-2 mb-0">Contents</p>
      <div class="d-flex align-items-center">
        <!-- contents icon on the left -->
        <img
          class="bbActionIcon me-2"
          :src="contentsImg"
          @click.stop="manageContents(activeItem)"
          alt="contents image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ToolTip from './ToolTip.vue'
import contentsImg from '../assets/images/bbContents.png'

export default {
  name: 'ItemContainerTab',
  components: {
    ToolTip,
  },
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    formatEnc: {
      type: Function,
      required: true,
    },
    displayDirectCnt: {
      type: String,
      required: true,
    },
    displayTotalCnt: {
      type: String,
      required: true,
    },
    displayContainerEnc: {
      type: String,
      required: true,
    },
    displayCapacityEnc: {
      type: String,
      required: true,
    },
    displayContentsEnc: {
      type: String,
      required: true,
    },
    displayTotEnc: {
      type: String,
      required: true,
    },
    displayAvailableEnc: {
      type: String,
      required: true,
    },
    manageContents: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      contentsImg,
    }
  },
}
</script>

<style scoped>
.bbActionIcon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
</style>
